import { RootState } from 'store/root-reducer';

export const getTransitsStatistic = (state: RootState) => state.statistics.transitsStatistic;
